import React from 'react';
import PropTypes from 'prop-types';
import MakeAsyncFunction from 'react-redux-promise-listener';
import { loadStripe } from '@stripe/stripe-js/pure';
import { Elements } from '@stripe/react-stripe-js';
import { promiseListener } from '../../../store/store';
import DonationPaypal from '../DonationForm/steps/06_PaymentsStep/DonationPaypal';
import { getStripePublishableKey } from '../../../utils/payments';
import { RG, SD } from '../../../utils/constants';
import DonationStripeButton from '../DonationForm/steps/06_PaymentsStep/DonationStripeButton';

const stripePromise = loadStripe(getStripePublishableKey());

/**
 * Some payments such as PayPal or Appeal Pay have their own payment buttons
 * that we render outside of the react-final-form.
 */
const DonationFormExternalDonateButton = ({
  currentStepName,
  paymentMethod = '',
  donationType,
}) => (
  <div
    className={`external-payment-button${currentStepName === 'payment' ? ' button-visible' : ''}`}
  >
    {/* PayPal button sits here and loads its scripts in invisible mode. */}
    <DonationPaypal
      visible={currentStepName === 'payment' && paymentMethod.startsWith('paypal_')}
      donationType={donationType}
    />
    {/* Stripe button sits here, loads its scripts and detects if payment button is supported. */}
    {getStripePublishableKey() && (
      <MakeAsyncFunction
        // TODO: Replace MakeAsyncFunction with createAsyncThunk
        // from redux-toolkit.
        listener={promiseListener}
        start="donationForm/donationFormSubmit"
        resolve="donationForm/donationFormSubmitSuccess"
        reject="donationForm/donationFormSubmitError"
        getPayload={(action) => action.payload}
      >
        {(onSubmitDonation) => (
          <Elements stripe={stripePromise}>
            <DonationStripeButton
              paymentMethodId={paymentMethod}
              showButton={
                currentStepName === 'payment' &&
                paymentMethod.startsWith('decoupled_stripe_button_')
              }
              onSubmitDonation={onSubmitDonation}
              donationType={donationType}
            />
          </Elements>
        )}
      </MakeAsyncFunction>
    )}
  </div>
);

DonationFormExternalDonateButton.propTypes = {
  paymentMethod: PropTypes.string,
  currentStepName: PropTypes.string.isRequired,
  donationType: PropTypes.oneOf([SD, RG]).isRequired,
};

export default DonationFormExternalDonateButton;
